import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, Resolve } from '@angular/router';
import { Progress } from './progress.model';
import { ProgressService } from './progress.service';


@Injectable()
export class ProgressListGuard implements Resolve<Progress> {

  constructor(public router: Router, private progressService: ProgressService) { }

  resolve() {
    return this.progressService.getProgressList(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/progress/progress-list.guard.ts